import NavigableValidator from "./navigableValidator";
import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";
import {RegexHelper} from "~/helpers/regexHelper";
import {ErrorType} from "~/enums/ErrorType";

export default class SlugValidator<T> extends NavigableValidator<T> {
  defaultMessage: string = 'Invalid value';
  defaultType = ErrorType.invalidValue;

  static isValid(value: string): boolean {
    return value === null || RegexHelper.slug.test(value)
  }

  _validate(model: INavigableValidatableModel<T>): void {
    let valid = SlugValidator.isValid(model[this.field]);
    if (!valid) {
      this.errors.push(this.buildValidationError(model, this.field));
    }
  }
}